import { SimpleStore } from "@core/store/store";
import { TagsApi } from "./tagsApi";

export class TagsService {
	constructor(private readonly tagsApi: TagsApi) {}
	tagsStore = new SimpleStore((id) => {
		return this.tagsApi.getTag(id);
	});
	suggestByValue = this.tagsApi.suggestByValue.bind(this.tagsApi);
}
